import StudentInformanceMain from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentInformanceMain";
import StudentPerformanceTabsMain from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentPerformanceTabs/StudentPerformanceTabsMain";
import { Col, Row } from "reactstrap";

const StudentPerformanceSection = ({ tabs }: any) => {
  return (
    <Row>
      <Col md="12">
        <StudentInformanceMain />
      </Col>
      <Col md="12" className="studentTabsDiv">
        <StudentPerformanceTabsMain tabs={tabs} />
      </Col>
    </Row>
  );
};
export default StudentPerformanceSection;
